import React from "react";
// import { useMap } from "react-leaflet";

import LocationIcon from "../../assets/img/locationIcon";
import { LocationIconStyled } from "./locationBtn.styles";

const LocationBtn = ({ setGetCenter }) => {
  //   const map2 = useMap();

  return (
    <LocationIconStyled
      onClick={() => setGetCenter(true)}
      className="shadow-sm"
    >
      <LocationIcon size="20" />
    </LocationIconStyled>
  );
};

export default LocationBtn;
